import { apiPost } from '../config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface IRequestSmsCodeParams {
  phone: string
}

async function fetchRequestSmsCode(path: string, body: IRequestSmsCodeParams) {
  const { data } = await apiPost<IRequestSmsCodeParams, void>({ path, body })

  return data
}

export const useRequestSmsCode = () => {
  const path = API_ROUTES.AUTHOR_AUTH_REQUEST_SMS
  const mutationFn = (url: string, body: IRequestSmsCodeParams) => fetchRequestSmsCode(url, body)

  return useMutationHook({ path, mutationFn })
}
